(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nr-adv-carrusel"] && !Shopify.designMode) return;
  try {
    
(() => {
  const arrancar = (raiz) => {
    if (!raiz || raiz.dataset.nrCarInit === '1') return;
    raiz.dataset.nrCarInit = '1';
    const pista = raiz.querySelector('[data-nr-car-pista]');
    const items = [...raiz.querySelectorAll('[data-nr-car-item]')];
    if (!pista || !items.length) return;
    const puntos = [...raiz.querySelectorAll('[data-nr-car-punto]')];
    const prev = raiz.querySelector('[data-nr-car-prev]');
    const next = raiz.querySelector('[data-nr-car-next]');
    const pad = () => parseFloat(getComputedStyle(pista).paddingLeft) || 0;

    const actual = () => {
      const x = pista.scrollLeft + pad();
      let mejor = 0, dist = Infinity;
      items.forEach((it, i) => { const d = Math.abs(it.offsetLeft - x); if (d < dist) { dist = d; mejor = i; } });
      return mejor;
    };
    const irA = (i) => {
      const it = items[Math.max(0, Math.min(items.length - 1, i))];
      pista.scrollTo({ left: it.offsetLeft - pad(), behavior: 'smooth' });
    };
    const pintar = () => {
      const i = actual();
      puntos.forEach((p, k) => { p.classList.toggle('is-activo', k === i); p.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
      if (prev) prev.disabled = pista.scrollLeft <= 2;
      if (next) next.disabled = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 2;
    };

    puntos.forEach((p) => p.addEventListener('click', () => irA(+p.dataset.nrCarPunto)));
    if (prev) prev.addEventListener('click', () => irA(actual() - 1));
    if (next) next.addEventListener('click', () => irA(actual() + 1));
    pista.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); irA(actual() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); irA(actual() - 1); }
    });
    let raf;
    pista.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(pintar); }, { passive: true });
    window.addEventListener('resize', pintar, { passive: true });
    pintar();
  };
  const boot = () => document.querySelectorAll('[data-nr-adv-car]').forEach(arrancar);
  document.addEventListener('DOMContentLoaded', boot);
  boot();
  document.addEventListener('shopify:section:load', (e) => arrancar(e.target.querySelector('[data-nr-adv-car]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nr-carrusel-infinito"] && !Shopify.designMode) return;
  try {
    
(() => {
  const iniciar = (sec) => {
    const pista = sec.querySelector('[data-nr-ci-pista]');
    const base = pista && pista.querySelector('.nr-ci__grupo:not([data-nr-ci-clon])');
    if (!base || !base.children.length) return;

    const medir = () => {
      const ancho = base.getBoundingClientRect().width;
      if (!ancho) return;
      // Copias suficientes para que nunca se vea un hueco, incluso con pocas imágenes.
      const necesarias = Math.max(1, Math.ceil(sec.clientWidth / ancho));
      let clones = pista.querySelectorAll('[data-nr-ci-clon]');
      for (let i = clones.length; i < necesarias; i++) {
        const c = base.cloneNode(true);
        c.setAttribute('aria-hidden', 'true');
        c.setAttribute('data-nr-ci-clon', '');
        c.querySelectorAll('[data-shopify-editor-block]').forEach((n) => n.removeAttribute('data-shopify-editor-block'));
        c.querySelectorAll('a').forEach((a) => a.setAttribute('tabindex', '-1'));
        pista.appendChild(c);
      }
      const velocidad = parseFloat(sec.dataset.velocidad) || 40;
      sec.style.setProperty('--ci-dist', ancho + 'px');
      sec.style.setProperty('--ci-dur', (ancho / velocidad).toFixed(2) + 's');
      sec.style.setProperty('--ci-sentido', sec.dataset.direccion === 'derecha' ? 'reverse' : 'normal');
    };

    if (sec._nrCi) sec._nrCi.disconnect();
    const ro = new ResizeObserver(medir);
    ro.observe(base);
    ro.observe(sec);

    // Solo se mueve (y carga las imágenes) cuando está cerca de la pantalla.
    const io = new IntersectionObserver((entradas) => {
      entradas.forEach((e) => {
        sec.classList.toggle('is-fuera', !e.isIntersecting);
        if (e.isIntersecting) sec.querySelectorAll('img[loading="lazy"]').forEach((img) => { img.loading = 'eager'; });
      });
    }, { rootMargin: '600px 0px' });
    io.observe(sec);

    sec._nrCi = { disconnect: () => { ro.disconnect(); io.disconnect(); } };
    medir();
  };

  const boot = (raiz) => (raiz || document).querySelectorAll('[data-nr-ci]').forEach(iniciar);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
  document.addEventListener('shopify:block:select', (e) => {
    const sec = e.target.closest && e.target.closest('[data-nr-ci]');
    if (sec) sec.classList.add('is-pausado');
  });
  document.addEventListener('shopify:block:deselect', (e) => {
    const sec = e.target.closest && e.target.closest('[data-nr-ci]');
    if (sec) sec.classList.remove('is-pausado');
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nr-galeria"] && !Shopify.designMode) return;
  try {
    
(() => {
  const arrancar = (raiz) => {
    if (!raiz || raiz.dataset.nrGalInit === '1') return;
    raiz.dataset.nrGalInit = '1';
    const pista = raiz.querySelector('[data-nr-gal-pista]');
    if (!pista) return;
    const items = [...raiz.querySelectorAll('[data-nr-gal-item]')];
    const puntos = [...raiz.querySelectorAll('[data-nr-gal-punto]')];
    const prev = raiz.querySelector('[data-nr-gal-prev]');
    const next = raiz.querySelector('[data-nr-gal-next]');

    const indiceVisible = () => {
      const centro = pista.scrollLeft + pista.clientWidth / 2;
      let mejor = 0, dist = Infinity;
      items.forEach((it, i) => {
        const c = it.offsetLeft + it.offsetWidth / 2 - pista.offsetLeft;
        const d = Math.abs(c - centro);
        if (d < dist) { dist = d; mejor = i; }
      });
      return mejor;
    };

    const irA = (i) => {
      const it = items[Math.max(0, Math.min(items.length - 1, i))];
      if (!it) return;
      pista.scrollTo({ left: it.offsetLeft - pista.offsetLeft - (pista.clientWidth - it.offsetWidth) / 2, behavior: 'smooth' });
    };

    const pintar = () => {
      const i = indiceVisible();
      puntos.forEach((p, k) => {
        p.classList.toggle('is-activo', k === i);
        p.setAttribute('aria-selected', k === i ? 'true' : 'false');
      });
      if (prev) prev.disabled = pista.scrollLeft <= 2;
      if (next) next.disabled = pista.scrollLeft + pista.clientWidth >= pista.scrollWidth - 2;
    };

    puntos.forEach((p) => p.addEventListener('click', () => irA(+p.dataset.nrGalPunto)));
    if (prev) prev.addEventListener('click', () => irA(indiceVisible() - 1));
    if (next) next.addEventListener('click', () => irA(indiceVisible() + 1));
    pista.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowRight') { e.preventDefault(); irA(indiceVisible() + 1); }
      if (e.key === 'ArrowLeft') { e.preventDefault(); irA(indiceVisible() - 1); }
    });
    let raf;
    pista.addEventListener('scroll', () => { cancelAnimationFrame(raf); raf = requestAnimationFrame(pintar); }, { passive: true });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(pintar);
    pintar();
  };
  const boot = () => document.querySelectorAll('[data-nr-gal]').forEach(arrancar);
  document.addEventListener('DOMContentLoaded', boot);
  boot();
  document.addEventListener('shopify:section:load', (e) => arrancar(e.target.querySelector('[data-nr-gal]')));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nr-header"] && !Shopify.designMode) return;
  try {
    
(() => {
  const boot = () => {
    const menu = document.querySelector('[data-nr-menu]');
    const openBtn = document.querySelector('[data-nr-menu-open]');
    if (menu && openBtn && !menu.dataset.init) {
      menu.dataset.init = '1';
      const open = () => { menu.hidden = false; openBtn.setAttribute('aria-expanded', 'true'); document.body.style.setProperty('overflow', 'hidden', 'important'); };
      const close = () => { menu.hidden = true; openBtn.setAttribute('aria-expanded', 'false'); document.body.style.removeProperty('overflow'); };
      openBtn.addEventListener('click', open);
      menu.querySelector('[data-nr-menu-close]').addEventListener('click', close);
      menu.addEventListener('click', (e) => { if (e.target === menu) close(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !menu.hidden) close(); });
    }
  };
  document.addEventListener('DOMContentLoaded', boot);
  boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nr-product"] && !Shopify.designMode) return;
  try {
    
(() => {
  const init = (root) => {
    if (!root || root.dataset.nrInit === '1') return;
    root.dataset.nrInit = '1';
    const $ = (s, c = root) => c.querySelector(s);
    const $$ = (s, c = root) => [...c.querySelectorAll(s)];

    const track = $('[data-nr-track]');
    const thumbs = $$('[data-nr-thumb]');

    // Fotos de la galería: la primera carga con prioridad y, apenas está, se bajan las demás
    // en orden y de a dos, para que al deslizar ya estén (si tocan la galería antes, arranca ahí).
    const fotos = $$('[data-nr-slide] img');
    if (fotos.length > 1) {
      const cola = fotos.slice(1);
      let enCurso = 0;
      let arrancada = false;
      const siguiente = () => {
        while (enCurso < 2 && cola.length) {
          const img = cola.shift();
          if (img.complete && img.naturalWidth) continue;
          enCurso++;
          const listo = () => { enCurso--; siguiente(); };
          img.addEventListener('load', listo, { once: true });
          img.addEventListener('error', listo, { once: true });
          img.loading = 'eager';
        }
      };
      const precargar = () => { if (arrancada) return; arrancada = true; siguiente(); };
      const primera = fotos[0];
      if (primera.complete) precargar();
      else {
        primera.addEventListener('load', precargar, { once: true });
        primera.addEventListener('error', precargar, { once: true });
      }
      if (track) ['touchstart', 'pointerdown', 'scroll'].forEach((ev) => track.addEventListener(ev, precargar, { once: true, passive: true }));
      const tira = $('[data-nr-thumbs]');
      if (tira) ['touchstart', 'pointerdown'].forEach((ev) => tira.addEventListener(ev, precargar, { once: true, passive: true }));
    }
    if (track && thumbs.length) {
      const slides = $$('[data-nr-slide]');
      thumbs.forEach((t) => t.addEventListener('click', () => {
        const i = +t.dataset.nrThumb;
        track.scrollTo({ left: slides[i].offsetLeft - track.offsetLeft, behavior: 'smooth' });
      }));
      let raf;
      track.addEventListener('scroll', () => {
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const i = Math.round(track.scrollLeft / track.clientWidth);
          thumbs.forEach((t, k) => t.classList.toggle('is-active', k === i));
          const active = thumbs[i];
          if (active) active.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        });
      }, { passive: true });
    }

    const lb = $('[data-nr-lightbox]');
    const zoom = $('[data-nr-zoom]');
    if (lb && zoom) {
      zoom.addEventListener('click', () => {
        const i = track ? Math.round(track.scrollLeft / track.clientWidth) : 0;
        const img = $$('[data-nr-slide] img')[i];
        const target = $('[data-nr-lightbox-img]', lb);
        if (img) { target.src = img.currentSrc || img.src; target.hidden = false; }
        lb.showModal();
      });
      $('[data-nr-lightbox-close]', lb).addEventListener('click', () => lb.close());
      lb.addEventListener('click', (e) => { if (e.target === lb) lb.close(); });
    }

    $$('[data-nr-pill]').forEach((pill) => {
      const modal = document.getElementById('nr-modal-' + pill.dataset.nrPill);
      if (!modal) return;
      const open = () => { modal.hidden = false; pill.setAttribute('aria-expanded', 'true'); document.body.style.setProperty('overflow', 'hidden', 'important'); };
      const close = () => { modal.hidden = true; pill.setAttribute('aria-expanded', 'false'); document.body.style.removeProperty('overflow'); };
      pill.addEventListener('click', open);
      modal.querySelectorAll('[data-nr-modal-close]').forEach((b) => b.addEventListener('click', close));
      modal.addEventListener('click', (e) => { if (e.target === modal) close(); });
      document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && !modal.hidden) close(); });
      const certBtn = modal.querySelector('[data-nr-cert-toggle]');
      const certImg = modal.querySelector('[data-nr-cert-img]');
      if (certBtn && certImg) certBtn.addEventListener('click', () => { certImg.hidden = !certImg.hidden; });
    });

    const form = $('[data-nr-buy]');
    if (!form) return;
    const cards = $$('[data-nr-card]', form);
    const idInput = $('[data-nr-variant-id]', form);
    const certEl = $('[data-nr-cert]');
    const shipEl = $('[data-nr-ship]');

    const selected = () => cards.find((c) => c.classList.contains('is-selected')) || cards[0] || null;

    const sync = () => {
      const card = selected();
      if (!card) return;
      if (idInput) idInput.value = card.dataset.variantId;
      if (certEl) {
        const tpl = certEl.dataset.tpl || '';
        certEl.textContent = tpl.replace('{compare}', card.dataset.compare || '');
      }
    };

    cards.forEach((card) => {
      const pick = () => {
        cards.forEach((c) => c.classList.remove('is-selected'));
        card.classList.add('is-selected');
        const r = card.querySelector('input');
        if (r) r.checked = true;
        sync();
      };
      card.addEventListener('click', pick);
      card.addEventListener('keydown', (e) => { if (e.key === ' ' || e.key === 'Enter') { e.preventDefault(); pick(); } });
    });

    if (shipEl) {
      const days = parseInt(form.dataset.shipDays || '0', 10) || 0;
      const habiles = form.dataset.shipBusiness === 'true';
      const d = new Date();
      d.setHours(12, 0, 0, 0);
      if (habiles) {
        let faltan = days;
        while (faltan > 0) {
          d.setDate(d.getDate() + 1);
          const dia = d.getDay();
          if (dia !== 0 && dia !== 6) faltan--;
        }
      } else {
        d.setDate(d.getDate() + days);
      }
      const loc = form.dataset.shipLocale || document.documentElement.lang || 'es-AR';
      const fmt = new Intl.DateTimeFormat(loc, { weekday: 'short', month: 'short', day: 'numeric' }).format(d);
      shipEl.innerHTML = (form.dataset.shipPrefix || '') + ' <strong>' + fmt + '</strong>';
    }

    sync();

    const errEl = $('[data-nr-error]');

    // Devuelve una promesa que se resuelve cuando el pixel registró el "agregó al carrito"
    // (más un margen para que el pedido salga a Meta), o al vencer el tope que le pida
    // quien espera: nunca se traba una compra por esperar a la medición.
    const vigilarPixelATC = () => {
      let resolver;
      const listo = new Promise((r) => { resolver = r; });
      let cerrado = false;
      let visto = false;
      let tope = 0;
      let restaurar = () => {};
      const terminar = () => { if (cerrado) return; cerrado = true; try { restaurar(); } catch (e) {} resolver(); };
      try {
        const orig = window.fbq;
        if (typeof orig === 'function') {
          const envuelto = function () {
            const res = orig.apply(this, arguments);
            for (let i = 0; i < arguments.length; i++) {
              if (arguments[i] === 'AddToCart') { visto = true; setTimeout(terminar, 400); break; }
            }
            return res;
          };
          for (const k in orig) { try { envuelto[k] = orig[k]; } catch (e) {} }
          Object.keys(orig).forEach((k) => { try { envuelto[k] = orig[k]; } catch (e) {} });
          window.fbq = envuelto;
          restaurar = () => { if (window.fbq === envuelto) window.fbq = orig; };
        }
      } catch (e) {}
      // El tope se cuenta desde que el carrito respondió (ahí está por avisar el pixel),
      // no desde el clic: si el carrito tarda, la medición no se pierde por apuro.
      return {
        listo,
        visto: () => visto,
        esperar: (ms) => { clearTimeout(tope); tope = setTimeout(terminar, ms); return listo; }
      };
    };

    // Con la app de packs en el medio, el pixel de Shopify no llega a emitir el
    // "agregó al carrito": ahí lo manda el tema, con los datos reales del carrito.
    const mandarATCaMeta = (carrito, variantId) => {
      try {
        if (typeof window.fbq !== 'function') return false;
        const linea = ((carrito && carrito.items) || []).filter((i) => String(i.variant_id) === String(variantId))[0] || {};
        const cantidad = linea.quantity || 1;
        const centavos = linea.final_line_price != null ? linea.final_line_price : ((carrito && carrito.total_price) || 0);
        const datos = {
          content_type: 'product_group',
          content_ids: [String(form.dataset.productoId || variantId)],
          content_name: linea.product_title || form.dataset.productoTitulo || '',
          contents: [{ id: String(variantId), quantity: cantidad }],
          value: centavos / 100,
          currency: (carrito && carrito.currency) || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'ARS'
        };
        let pixeles = [];
        try { pixeles = (window.fbq.getState().pixels || []).map((px) => px.id); } catch (e) {}
        if (pixeles.length) pixeles.forEach((id) => window.fbq('trackSingle', id, 'AddToCart', datos));
        else window.fbq('track', 'AddToCart', datos);
        return true;
      } catch (e) { return false; }
    };

    const submit = async (btn) => {
      const card = selected();
      const variantId = card ? card.dataset.variantId : (idInput && idInput.value);
      if (!variantId) return;
      const label = btn.textContent;
      btn.disabled = true;
      const raiz = window.Shopify?.routes?.root || '/';
      enderezarKaching(); // por si la app de packs cargó después que el tema
      // El pixel avisa del "agregó al carrito" llamando a fbq unos ms después de que responde
      // el carrito, y recién ahí sale el pedido a Meta. Lo escuchamos desde antes de agregar
      // para no perdérnoslo, y esperamos a que salga antes de irnos al checkout.
      const pixelATC = vigilarPixelATC();
      try {
        // el carrito se vacía primero: si vuelve atrás y compra de nuevo, no se acumula
        await fetch(raiz + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } });
        const res = await fetch(raiz + 'cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: +variantId, quantity: 1 }] })
        });
        if (!res.ok) throw new Error((await res.json()).description || 'Error');
        if (errEl) errEl.hidden = true;
        if (form.dataset.checkoutDirecto === 'true') {
          // esperar a que la app de packs termine de armar el carrito antes de irnos
          let intentos = 0;
          let carrito = null;
          while (intentos < 12) {
            carrito = await (await fetch(raiz + 'cart.js', { headers: { Accept: 'application/json' } })).json();
            if (carrito.item_count > 0) break;
            await new Promise((r) => setTimeout(r, 250));
            intentos++;
          }
          await pixelATC.esperar(600);
          if (!pixelATC.visto() && mandarATCaMeta(carrito, variantId)) {
            await new Promise((r) => setTimeout(r, 250)); // que el aviso alcance a salir
          }
          window.location.assign(raiz + 'checkout');
          return;
        }
        pixelATC.esperar(1500); // sin await: solo para que se desenganche del pixel
        document.dispatchEvent(new CustomEvent('nr:cart:open'));
      } catch (e) {
        if (errEl) { errEl.textContent = e.message; errEl.hidden = false; }
      } finally {
        btn.disabled = false;
        btn.textContent = label;
      }
    };

    form.addEventListener('submit', (e) => { e.preventDefault(); submit($('[data-nr-atc]', form)); });
    const sticky = $('[data-nr-sticky]');
    const atc = $('[data-nr-atc]', form);
    if (sticky && atc && 'IntersectionObserver' in window) {
      new IntersectionObserver((entries) => {
        entries.forEach((en) => { sticky.hidden = en.isIntersecting || en.boundingClientRect.top > 0; });
      }, { rootMargin: '0px 0px -80px 0px' }).observe(atc);
    }
  };

  const irACompra = (e) => {
    if (e) e.preventDefault();
    const visible = (sel) => {
      for (const el of document.querySelectorAll(sel)) {
        if (el.getBoundingClientRect().height > 0) return el;
      }
      return null;
    };
    const destino = visible('[data-nr-card]') || visible('.kaching-bundles') || visible('[data-nr-buy]');
    if (!destino) return;
    destino.style.scrollMarginTop = '90px';
    destino.scrollIntoView({ behavior: 'smooth', block: 'start' });
    const marcar = document.querySelector('[data-nr-atc]');
    if (marcar) {
      marcar.classList.add('nr-atc--resalta');
      setTimeout(() => marcar.classList.remove('nr-atc--resalta'), 1600);
    }
  };

  const enlazarIr = () => document.querySelectorAll('[data-nr-sticky-ir],[data-nr-ir-compra]').forEach((b) => {
    if (b.dataset.nrIrInit === '1') return;
    b.dataset.nrIrInit = '1';
    b.addEventListener('click', irACompra);
  });

  // La app de packs (Kaching) manda los agregados al carrito por una copia cruda del
  // navegador, y así Shopify no se entera de que hubo carrito: no lo registra en
  // Vista en vivo ni avisa a los pixeles. Su pedido ya viene con su propia propiedad,
  // y en ese caso la app lo deja pasar tal cual, así que lo devolvemos al camino normal.
  const enderezarKaching = () => {
    try {
      const bruto = window.__kachingBundlesRawFetch;
      if (typeof bruto !== 'function' || bruto.nrEnderezado) return;
      let dentro = false;
      const desviado = function (url, opciones) {
        let cuerpo = '';
        try { cuerpo = opciones && typeof opciones.body === 'string' ? opciones.body : ''; } catch (e) {}
        const esCarrito = /\/cart\/(add|change|update)/.test(String(url || ''));
        if (!dentro && esCarrito && cuerpo.indexOf('__kaching_bundles') >= 0) {
          dentro = true; // cerrojo: si la app volviera a entrar, usa su camino y no se cicla
          try { return window.fetch.apply(this, arguments); }
          finally { setTimeout(() => { dentro = false; }, 0); }
        }
        return bruto.apply(this, arguments);
      };
      desviado.nrEnderezado = true;
      window.__kachingBundlesRawFetch = desviado;
    } catch (e) {}
  };

  // Contador: cuenta hacia la fecha real cargada en el editor. Si ya pasó, se esconde o avisa.
  const iniciarCuenta = () => {
    document.querySelectorAll('[data-nr-cd]').forEach((el) => {
      if (el.dataset.nrCdInit === '1') return;
      el.dataset.nrCdInit = '1';
      const salida = el.querySelector('[data-nr-cd-tiempo]');
      const fin = Date.parse(el.dataset.fin || '');
      if (!salida || isNaN(fin)) { el.hidden = true; return; }
      const dos = (n) => String(n).padStart(2, '0');
      const bloques = el.querySelector('[data-nr-cd-bloques]');
      const cajaH = el.querySelector('[data-nr-cd-h]');
      const cajaM = el.querySelector('[data-nr-cd-m]');
      const cajaS = el.querySelector('[data-nr-cd-s]');
      const etiquetas = el.querySelectorAll('.nr-cd__bloque i');
      let reloj = 0;
      const pintar = () => {
        const resta = fin - Date.now();
        if (resta <= 0) {
          clearInterval(reloj);
          if (el.dataset.ocultar === 'true') { el.hidden = true; return; }
          el.classList.add('is-terminado');
          salida.textContent = el.dataset.terminado || '';
          return;
        }
        const seg = Math.floor(resta / 1000);
        const d = Math.floor(seg / 86400);
        const h = Math.floor((seg % 86400) / 3600);
        const m = Math.floor((seg % 3600) / 60);
        const s = seg % 60;
        const formato = el.dataset.formato || 'auto';
        if (bloques) {
          const porDias = formato === 'dh' || (formato === 'auto' && d > 0);
          cajaH.textContent = porDias ? d : dos(h + d * 24);
          cajaM.textContent = porDias ? dos(h) : dos(m);
          cajaS.textContent = porDias ? dos(m) : dos(s);
          if (etiquetas.length === 3) {
            etiquetas[0].textContent = porDias ? 'días' : 'hs';
            etiquetas[1].textContent = porDias ? 'hs' : 'min';
            etiquetas[2].textContent = porDias ? 'min' : 'seg';
          }
          return;
        }
        if (formato === 'dh' || (formato === 'auto' && d > 0)) {
          salida.textContent = d + ' d ' + dos(h) + ' h ' + dos(m) + ' m';
        } else {
          salida.textContent = dos(h + d * 24) + ':' + dos(m) + ':' + dos(s);
        }
      };
      pintar();
      reloj = setInterval(pintar, 1000);
    });
  };

  const boot = () => { enderezarKaching(); iniciarCuenta(); document.querySelectorAll('[data-nr-product]').forEach(init); enlazarIr(); };
  document.addEventListener('DOMContentLoaded', boot);
  boot();
  document.addEventListener('shopify:section:load', (e) => { init(e.target.querySelector('[data-nr-product]')); enlazarIr(); });
})();

(() => {
  // "Personas viendo ahora mismo": arranca al azar entre el mínimo y el máximo (a veces en el pico),
  // se mueve de a 1–3 cada 8–15 segundos sin salir del rango y se mantiene durante la visita.
  const azar = (a, b) => a + Math.floor(Math.random() * (b - a + 1));
  const iniciar = (el) => {
    if (el.dataset.nrIniciado === '1') return;
    el.dataset.nrIniciado = '1';
    const min = +el.dataset.min || 27;
    const max = Math.max(+el.dataset.max || 54, min);
    const pico = +el.dataset.pico || 0;
    const prob = (+el.dataset.prob || 0) / 100;
    let n = 0;
    try { n = +sessionStorage.getItem('nr-viendo') || 0; } catch (e) {}
    if (!n) n = pico && Math.random() < prob ? pico : azar(min, max);
    let desde = min, hasta = max;
    if (pico && Math.abs(n - pico) <= 3) { desde = pico - 3; hasta = pico + 3; }
    else n = Math.min(max, Math.max(min, n));
    const mostrar = () => {
      el.textContent = n;
      try { sessionStorage.setItem('nr-viendo', n); } catch (e) {}
    };
    const mover = () => {
      n = Math.min(hasta, Math.max(desde, n + (Math.random() < 0.5 ? -1 : 1) * azar(1, 3)));
      mostrar();
      setTimeout(mover, azar(8, 15) * 1000);
    };
    mostrar();
    setTimeout(mover, azar(8, 15) * 1000);
  };
  const boot = () => document.querySelectorAll('[data-nr-viendo]').forEach(iniciar);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nr-reviews"] && !Shopify.designMode) return;
  try {
    
(() => {
  const boot = () => {
    document.querySelectorAll('[data-nr-reviews]:not([data-init])').forEach((root) => {
      root.dataset.init = '1';
      const list = root.querySelector('[data-nr-review-list]');
      const more = root.querySelector('[data-nr-more]');
      if (more) more.addEventListener('click', () => {
        list.querySelectorAll('[hidden]').forEach((el) => { el.hidden = false; });
        more.hidden = true;
      });
    });
  };
  document.addEventListener('DOMContentLoaded', boot);
  boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nr-routine"] && !Shopify.designMode) return;
  try {
    
(() => {
  const encender = (v) => {
    if (!v || v.querySelector('source[data-src]')) return;   // todavía no cargó
    v.muted = true;            // iOS exige muted por propiedad, no solo por atributo
    v.defaultMuted = true;
    v.loop = true;
    const intento = v.play();
    if (intento && intento.catch) intento.catch(() => {});
  };
  // Las fuentes llegan en data-src: se cargan recién cuando el video se acerca a la pantalla.
  const cargar = (v) => {
    if (v.dataset.nrCargado === '1') return;
    v.dataset.nrCargado = '1';
    v.querySelectorAll('source[data-src]').forEach((s) => { s.src = s.dataset.src; s.removeAttribute('data-src'); });
    v.load();
    encender(v);
  };
  const io = 'IntersectionObserver' in window
    ? new IntersectionObserver((entradas) => entradas.forEach((e) => {
        if (!e.isIntersecting) return;
        io.unobserve(e.target);
        cargar(e.target);
      }), { rootMargin: '400px 0px' })
    : null;
  const vigilar = (v) => {
    if (v.dataset.nrLoopInit === '1') return;
    v.dataset.nrLoopInit = '1';
    // si el navegador lo frena (batería, cambio de pestaña, fin de buffer), lo reanudamos
    ['pause', 'stalled', 'suspend', 'ended'].forEach((ev) => v.addEventListener(ev, () => encender(v)));
    v.addEventListener('loadeddata', () => encender(v));
    if (!v.querySelector('source[data-src]')) encender(v);
    else if (io) io.observe(v);
    else cargar(v);
  };
  const boot = () => {
    const videos = [...document.querySelectorAll('.nr-routine video[data-nr-loop]')];
    videos.forEach(vigilar);
    if (!videos.length) return;
    const reanudar = () => videos.forEach(encender);
    document.addEventListener('visibilitychange', () => { if (!document.hidden) reanudar(); });
    window.addEventListener('pageshow', reanudar);
    ['touchstart', 'click', 'scroll'].forEach((ev) =>
      window.addEventListener(ev, reanudar, { once: true, passive: true }));
  };
  document.addEventListener('DOMContentLoaded', boot);
  boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nr-steps"] && !Shopify.designMode) return;
  try {
    
(() => {
  const boot = () => {
    const items = document.querySelectorAll('[data-nr-step]:not([data-init])');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) { items.forEach(i => i.classList.add('is-open')); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add('is-open'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -18% 0px', threshold: .35 });
    items.forEach((i) => { i.dataset.init = '1'; io.observe(i); });
  };
  document.addEventListener('DOMContentLoaded', boot);
  boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nr-video-vertical"] && !Shopify.designMode) return;
  try {
    
(() => {
  const iniciar = (marco) => {
    if (marco.dataset.nrVvInit === '1') return;
    marco.dataset.nrVvInit = '1';
    const video = marco.querySelector('[data-nr-vv-video]');
    const play = marco.querySelector('[data-nr-vv-play]');
    const sonido = marco.querySelector('[data-nr-vv-sonido]');
    if (!video || !play) return;
    const iconoAudio = sonido && sonido.querySelector('.nr-vv__icono-audio');
    const iconoMudo = sonido && sonido.querySelector('.nr-vv__icono-mudo');

    // Los <svg> no entienden la propiedad hidden, hay que tocar el atributo.
    const mostrar = (el, visible) => {
      if (!el) return;
      if (visible) el.removeAttribute('hidden');
      else el.setAttribute('hidden', '');
    };

    const pintarSonido = () => {
      if (!sonido) return;
      mostrar(sonido, true);
      mostrar(iconoAudio, !video.muted);
      mostrar(iconoMudo, video.muted);
      sonido.setAttribute('aria-label', video.muted ? 'Activar el sonido' : 'Silenciar el video');
    };

    // Nada se descarga hasta que tocan play: algunos navegadores, con solo pedir
    // los datos de arranque, se bajaban el archivo completo.

    const arrancar = () => {
      // El video se descarga recién acá: antes solo pesaba la portada.
      video.muted = marco.dataset.conSonido === 'true' ? false : true;
      if (video.readyState < 3) marco.classList.add('is-cargando');
      const p = video.play();
      if (p && p.catch) {
        p.catch(() => {
          // Si el navegador no deja con sonido, arranca en silencio y avisa con el ícono.
          video.muted = true;
          pintarSonido();
          const r = video.play();
          if (r && r.catch) r.catch(() => {});
        });
      }
    };

    const alternar = () => { if (video.paused) arrancar(); else video.pause(); };

    play.addEventListener('click', (e) => { e.preventDefault(); arrancar(); });
    video.addEventListener('click', alternar);
    video.addEventListener('play', () => { marco.classList.add('is-reproduciendo', 'is-iniciado'); pintarSonido(); });
    video.addEventListener('playing', () => { marco.classList.remove('is-cargando'); });
    video.addEventListener('waiting', () => { marco.classList.add('is-cargando'); });
    video.addEventListener('pause', () => { marco.classList.remove('is-reproduciendo', 'is-cargando'); });

    if (sonido) {
      sonido.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        video.muted = !video.muted;
        pintarSonido();
      });
    }
  };

  const boot = (raiz) => (raiz || document).querySelectorAll('[data-nr-vv]').forEach(iniciar);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => boot());
  else boot();
  document.addEventListener('shopify:section:load', (e) => boot(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nr-weeks"] && !Shopify.designMode) return;
  try {
    
(() => {
  const boot = () => {
    document.querySelectorAll('[data-nr-weeks]:not([data-init])').forEach((root) => {
      root.dataset.init = '1';
      const items = [...root.querySelectorAll('[data-nr-week-item]')];
      items.forEach((item) => {
        const trigger = item.querySelector('[data-nr-week-trigger]');
        const panel = item.querySelector('[data-nr-week-panel]');
        trigger.addEventListener('click', () => {
          const willOpen = !item.classList.contains('is-open');
          items.forEach((other) => {
            other.classList.remove('is-open');
            other.querySelector('[data-nr-week-trigger]').setAttribute('aria-expanded', 'false');
            other.querySelector('[data-nr-week-panel]').hidden = true;
          });
          if (willOpen) {
            item.classList.add('is-open');
            trigger.setAttribute('aria-expanded', 'true');
            panel.hidden = false;
          }
        });
      });
    });
  };
  document.addEventListener('DOMContentLoaded', boot);
  boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();
})();
